import { getSessionStorage, StorageKey } from '@utils/StorageUtils';
import { Country, PageName } from '@utils/pageConfig/Types';
import { Action, SellerInsightsRetailerClientTypes } from '@state/actions/Type';

export interface SellerInsightsRetailerClientState {
  clientId: number;
  countries: Country[];
  clientName?: string;
  pageViewing?: PageName;
}

const getInitialState = () => {
  const storeSellerInsightsRetailerClient = JSON.parse(
    getSessionStorage(StorageKey.SellerInsightsRetailerClient) as string,
  );

  if (storeSellerInsightsRetailerClient) {
    return {
      clientId: storeSellerInsightsRetailerClient.clientId,
      countries: storeSellerInsightsRetailerClient.countries,
      pageViewing: storeSellerInsightsRetailerClient.pageViewing,
    };
  }

  return Object.freeze({
    clientId: -1, // -1 for default clientId
    countries: [
      {
        id: '',
        name: '',
        currency: '',
      },
    ],
  });
};

const SellerInsightsRetailerClientReducer = (
  state: SellerInsightsRetailerClientState = getInitialState(), // NOSONAR typescript:S1788
  action: Action,
) => {
  if (action.type === SellerInsightsRetailerClientTypes.SellerInsightsRetailerClientUpdate) {
    return {
      ...state,
      clientId: action.payload.clientId,
      countries: action.payload.countries,
      pageViewing: action.payload.pageViewing,
    };
  }
  return state;
};

export default SellerInsightsRetailerClientReducer;
